import {withFieldGroup} from '@cypro/ui/integrations/form'
import {Box, chakra, Text} from '@chakra-ui/react'

interface Props {
  name?: string
}

export const IndividualDrugForm = withFieldGroup({
  defaultValues: {},
  props: {} as Props,
  render: ({group, name}) => {
    return (
      <Box display="flex" flexDirection="column">
        <Box display="flex">
          <chakra.div padding="3" display="flex" alignItems="center" fontSize="sm" fontWeight="medium" flex="1 1 0%">
            <Text fontWeight={'normal'} fontSize={'sm'} color={'text'}>
              {name}
            </Text>
          </chakra.div>
          <chakra.div padding="3" display="flex" alignItems="center" fontSize="sm" fontWeight="medium" flex="1 1 0%">
            <group.AppField name={`doseReduction`}>
              {field => <field.NumberInput label="" hideLabel placeholder="0" bgColor="white" />}
            </group.AppField>
          </chakra.div>
        </Box>
      </Box>
    )
  },
})
